import { Report } from '@/typings/api/Report'
import { dateFormatter } from '@/helpers/dateFormatter'
import { createComponentProgrammatic } from '@/helpers/createComponentProgrammatic'


export const MODULE_NAME = 'lk-reports'

export const LK_REPORT_ROUTES = {
  LAYOUT: MODULE_NAME,
  LIST: `${MODULE_NAME}.list`,
  VIEW: `${MODULE_NAME}.view`,
} as const

export const geReportFilename = (data: Report) => {
  const createdAt = dateFormatter(data.created_at)
  const label = `${data.title} ${createdAt}.xlsx`
  return label
}

export const createYearModal = (parent: Vue, propsData: unknown) => {
  const AsyncComponent = import(
    /* webpackChunkName: "LKReportsYearModal" */
    './components/LKReportsYearModal.vue'
  )

  const result = createComponentProgrammatic(
    AsyncComponent,
    parent,
    propsData,
  )

  return result
}
